import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Packages from '@/views/Packages'
import Home from '@/views/Home'
import Prealert from '@/views/Prealert'
import Prealert_form from '@/views/Prealert-form'
import Notification from '@/views/Notification'
import Office from '@/views/Office'
import PackageDetails from '@/views/PackageDetails'
import PackageSignature from '@/views/PackageSignature'
import Chats from '@/views/Chats'
import Emergencies from '@/views/Emergencies'
import Signup from '@/views/Signup'
import Profile from '@/views/Profile'
import Delivery from '@/views/Delivery'
import DeliveryForm from '@/views/DeliveryForm'
import Help from '@/views/Help'
import Claims from '@/views/Claims'
import Invoice from '@/views/Invoice'
import TermsConditions from '@/views/TermsConditions'
import Courier from '@/views/Courier'
import Message from '@/views/Message'



import Store from '../store/'

Vue.use(Router)
const appRouter = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next()
        } else {
          next('/home')
        }
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next()
        } else {
          next('/home')
        }
      }
    },
    {
      path: '/packages/:status',
      name: 'Packages',
      component: Packages,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/courier',
      name: 'Courier',
      component: Courier,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },


    {
      path: '/claims',
      name: 'Claims',
      component: Claims,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/invoice',
      name: 'Invoice',
      component: Invoice,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },

    {
      path: '/prealert',
      name: 'Prealert',
      component: Prealert,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/prealert-form',
      name: 'Prealert form',
      component: Prealert_form,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },

    {
      path: '/office',
      name: 'Office',
      component: Office,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    }, {
      path: '/delivery',
      name: 'Delivery',
      component: Delivery,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },

    {
      path: '/termsconditions',
      name: 'Terms Conditions',
      component: TermsConditions,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next()
        } else {
          next('/home')
        }
      }
    },
    {
      path: '/delivery-form',
      name: 'delivery-form',
      component: DeliveryForm,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    }, {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    }, {
      path: '/notification',
      name: 'Notification',
      component: Notification,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },

    {
      path: '/PackageDetails/:id',
      name: 'PackageDetails',
      component: PackageDetails,
      props: true,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/PackageSignature/:selectOwner',
      name: 'PackageSignature',
      component: PackageSignature,
      props: true,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/chats',
      name: 'Chats',
      component: Chats,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/emergencies',
      name: 'Emergencies',
      component: Emergencies,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '/message',
      name: 'Messages',
      component: Message,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/')
        } else {
          next()
        }
      }
    },
    {
      path: '*',
      name: 'All',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (Store.getters.login === false) {
          next('/home')
        } else {
          next()
        }
      }
    },

  ]
})

export default appRouter